import { Button, Muted, Screen, Stack, space } from '@biopeak/ui';
import { useSession } from '../lib/session.tsx';

/**
 * Usuário autenticado, mas sem linha em `doctors`.
 *
 * Não é um estado de erro no sentido técnico — é o resultado correto de
 * alguém entrar com uma conta que existe no Supabase Auth mas nunca foi
 * vinculada por `cadastrar-medico.sql`. Sem "próximo passo" para oferecer
 * aqui: só administração da clínica resolve isso.
 */
export function NotAuthorized() {
  const { signOut } = useSession();

  return (
    <Screen style={{ justifyContent: 'center', minHeight: '100vh', maxWidth: '420px' }}>
      <Stack gap={space.sm}>
        <h1>Acesso não configurado</h1>
        <Muted>
          Sua conta existe, mas ainda não está vinculada a um cadastro de
          médico neste sistema. Fale com a administração da clínica.
        </Muted>
      </Stack>
      <Button variant="secondary" onClick={signOut}>
        Sair
      </Button>
    </Screen>
  );
}
